import React, { Suspense } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Loader from './component/loader';
import LogoLight from './assets/images/logo-light.png';
import { DealersProvider } from './context/DealersContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './pages/ProtectedRoute';
import { CarsProvider } from './context/CarsContext';
import MyAccess from './pages/my-account/MyAccess';
import { TrackingProvider } from './context/TrackingContext';
// All Headers
const Header = React.lazy(() => import('./layouts/header/header'));

// All Footers
const FooterNew01 = React.lazy(() => import('./layouts/footer/footer-new-01'));
// const FooterStyle01 = React.lazy(() => import('./layouts/footer/footer-style-01'));
// const FooterStyle02 = React.lazy(() => import('./layouts/footer/footer-style-02'));

// Back to Top
const BackTop = React.lazy(() => import('./component/back-top'));

// Pages
const Home = React.lazy(() => import('./pages/home/home'));
const CarGrid = React.lazy(() => import('./pages/car/car-grid'));
const Dealer = React.lazy(() => import('./pages/dealer/dealer-cars'));
const AllDealers = React.lazy(() => import('./pages/dealer/all-dealers'));
const CarListing = React.lazy(() => import('./pages/car/car-list'));
const CarDetails = React.lazy(() => import('./pages/car/car-details'));

const Login = React.lazy(() => import('./pages/my-account/login'));
const AddCar = React.lazy(() => import('./pages/my-account/AddCar'));
const MyAccount = React.lazy(() => import('./pages/my-account/MyAccount'));
const MyCars = React.lazy(() => import('./pages/my-account/MyCars'));
const MyTeam = React.lazy(() => import('./pages/my-account/MyTeam'));
const Error404 = React.lazy(() => import('./pages/error404/error404'));

// const Blog = React.lazy(() => import('./pages/blog/blog'));
// const BlogLeftSideBar = React.lazy(() => import('./pages/blog/blog-left-sidebar'));
// const BlogRightSideBar = React.lazy(() => import('./pages/blog/blog-right-sidebar'));
// const BlogGrid = React.lazy(() => import('./pages/blog/blog-grid'));
// const BlogSingle = React.lazy(() => import('./pages/blog/blog-details'));

// const ModernContact = React.lazy(() => import('./pages/modern-contact'));
// const ContactUs = React.lazy(() => import('./pages/contact/contact'));
// const ContactUsTwo = React.lazy(() => import('./pages/contact/contact-02'));
// const Faq = React.lazy(() => import('./pages/faq/faq'));
// const ComingSoon = React.lazy(() => import('./pages/coming-soon'));
// const PrivacyPolicy = React.lazy(() => import('./pages/privacy-policy'));
// const TermsConditions = React.lazy(() => import('./pages/terms-conditions'));
// const TypoGraphy = React.lazy(() => import('./pages/typography'));
// const ModernAbout = React.lazy(() => import('./pages/modern-about'));
// const AboutUs = React.lazy(() => import('./pages/about-us'));
// const AboutUsTwo = React.lazy(() => import('./pages/about-us/about-02'));
// const Careers = React.lazy(() => import('./pages/careers'));
// const Team = React.lazy(() => import('./pages/team/team'));
// const TeamTwo = React.lazy(() => import('./pages/team/team-02'));
// const TeamSingle = React.lazy(() => import('./pages/team/team-single'));
// const ModernService = React.lazy(() => import('./pages/modern-services'));
// const Service = React.lazy(() => import('./pages/services/services'));
// const PageLeftSideBar = React.lazy(() => import('./pages/page-sidebar/page-left-sidebar'));
// const PageRightSideBar = React.lazy(() => import('./pages/page-sidebar/page-right-sidebar'));
// const PageBothSideBar = React.lazy(() => import('./pages/page-sidebar/page-both-sidebar'));

function App() {
  const location = useLocation();
  const hideFooter = location.pathname !== '';

  return (
    <Suspense fallback={<Loader />}>
      <div className="main-wrapper">
        <AuthProvider>
          <DealersProvider>
            <CarsProvider>
              <TrackingProvider>
                <Routes>
                  <Route
                    path="/"
                    element={
                      <Header
                        className="header-transprent"
                        siteLogo={LogoLight}
                      />
                    }
                  >
                    {/* Home */}
                    <Route index element={<Home />} />

                    {/* Pages */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/dealer/:id" element={<Dealer />} />
                    <Route path="/dealers" element={<AllDealers />} />
                    <Route path="/car-details/:id" element={<CarDetails />} />

                    <Route
                      path="/add-car"
                      element={
                        <ProtectedRoute>
                          <AddCar />
                        </ProtectedRoute>
                      }
                    />

                    <Route
                      path="/edit-car/:carId"
                      element={
                        <ProtectedRoute>
                          <AddCar />
                        </ProtectedRoute>
                      }
                    />

                    <Route
                      path="/my-account"
                      element={
                        <ProtectedRoute>
                          <MyAccount />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/my-cars"
                      element={
                        <ProtectedRoute>
                          <MyCars />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/my-team"
                      element={
                        <ProtectedRoute>
                          <MyTeam />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/my-access"
                      element={
                        <ProtectedRoute>
                          <MyAccess />
                        </ProtectedRoute>
                      }
                    />

                    <Route path="/car-grid" element={<CarGrid />} />
                    <Route path="/car-list" element={<CarListing />} />
                    <Route path="/*" element={<Error404 />} />

                    {/* Other Not yet used Pages */}
                    {/* <Route path="/contact-modern" element={<ModernContact />} />
                  <Route path="/contact" element={<ContactUs />} />
                  <Route path="/contact-02" element={<ContactUsTwo />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog-left-sidebar" element={<BlogLeftSideBar />} />
                  <Route path="/blog-right-sidebar" element={<BlogRightSideBar />} />
                  <Route path="/blog-grid" element={<BlogGrid />} />
                  <Route path="/blog-details/:id" element={<BlogSingle />} />
                  <Route path="/faq" element={<Faq />} />
                  <Route path="/coming-soon" element={<ComingSoon />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/page-left-sidebar" element={<PageLeftSideBar />} />
                  <Route path="/page-right-sidebar" element={<PageRightSideBar />} />
                  <Route path="/page-both-sidebar" element={<PageBothSideBar />} />
                  <Route path="/terms-and-conditions" element={<TermsConditions />} />
                  <Route path="/typography" element={<TypoGraphy />} />
                  <Route path="/about-modern" element={<ModernAbout />} />
                  <Route path="/about-us" element={<AboutUs />} />
                  <Route path="/about-02" element={<AboutUsTwo />} />
                  <Route path="/careers" element={<Careers />} />
                  <Route path="/team" element={<Team />} />
                  <Route path="/team-02" element={<TeamTwo />} />
                  <Route path="/team-details/:id" element={<TeamSingle />} />
                  <Route path="/service-modern" element={<ModernService />} />
                  <Route path="/service" element={<Service />} /> */}
                  </Route>
                </Routes>

                {/* All Footer */}
                {hideFooter && (
                  <Routes>
                    {/* Footer Default */}
                    <Route path="/*" element={<FooterNew01 />} />{' '}
                    {/* Footer Style 03 */}
                    {/* <Route path="/modern-home2" element={<FooterStyle01 />} />{' '} */}
                    {/* Footer Style 03 */}
                    {/* <Route path="/modern-home3" element={<FooterStyle02 />} />{' '} */}
                  </Routes>
                )}

                {/* Back to Top */}
                <BackTop />
              </TrackingProvider>
            </CarsProvider>
          </DealersProvider>
        </AuthProvider>
      </div>
    </Suspense>
  );
}

export default App;
